import { Link } from '@tanstack/react-router';
import { t } from '../i18n/lingua.js';

/**
 * Quando l'indirizzo non esiste.
 *
 * Non basta dire «non trovato»: nella 3.0 i percorsi sono cambiati — gli
 * indirizzi sono in inglese — e chi arriva qui quasi sempre ha un collegamento
 * vecchio nei preferiti. Glielo si dice, con gli esempi, invece di lasciarlo
 * pensare che il programma sia rotto.
 */
export function NonTrovata() {
  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">{t('Questo indirizzo non esiste')}</h1>
          <div className="page-sub">{t('Forse è un indirizzo vecchio')}</div>
        </div>
      </div>

      <div className="cantiere">
        <h2>{t('Forse è un indirizzo vecchio')}</h2>
        <p>
          {t('I percorsi delle pagine sono cambiati:')} <span className="num">/clienti</span>{' '}
          {t('ora si chiama')} <span className="num">/customers</span>,{' '}
          <span className="num">/ordini</span> {t('è diventato')}{' '}
          <span className="num">/sales-orders</span>
          {t('. Se hai un collegamento salvato, aggiornalo.')}
        </p>
        <p>
          <Link to="/">{t('Torna al mio lavoro')}</Link> {t('oppure scegli una voce dal menu.')}
        </p>
      </div>
    </>
  );
}
